import type { AvailableMeals } from '@/types/pops'
import type { CMSProgramOptionGroups } from '@/types/sanity'
import type { Dayjs } from 'dayjs'

export const getInputType = (
  groupType: 'select' | 'multiselect',
): 'radio' | 'checkbox' => {
  return groupType === 'select' ? 'radio' : 'checkbox'
}

export const getISO8601Date = (date: Dayjs) => {
  return date.format('YYYY-MM-DD')
}

export const buildMealIdForSku = (meals: Partial<AvailableMeals[]>) => {
  let meal_sku = ''

  if (meals.includes('breakfast')) meal_sku = meal_sku.concat('B')
  if (meals.includes('lunch')) meal_sku = meal_sku.concat('L')
  if (meals.includes('dinner')) meal_sku = meal_sku.concat('D')

  return meal_sku
}

export const getAllOptionGroupContentType = (
  optionGroups: CMSProgramOptionGroups[],
) => {
  return [
    ...new Set(
      optionGroups
        .map((group) => group && group.groupChildType)
        .filter(Boolean),
    ),
  ]
}
